// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class PlanningProduct {
  readonly id: string;
  readonly planningNodeId: string;
  readonly productId: string | null;
  readonly name: string;
  readonly classification: Enums.PlanningProductClassification;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.planningNodeId = data.planningNodeId === undefined ? NIL_UUID : data.planningNodeId;
    this.productId = data.productId === undefined ? null : data.productId;
    this.name = data.name === undefined ? '' : data.name;
    this.classification =
      data.classification === undefined
        ? Enums.PlanningProductClassification.Aggregates
        : data.classification;
  }

  static zero(): PlanningProduct {
    const zeroValues: ExcludeMethodsDeep<PlanningProduct> = {
      id: NIL_UUID,
      planningNodeId: NIL_UUID,
      productId: null,
      name: '',
      classification: Enums.PlanningProductClassification.Aggregates,
    };
    return new PlanningProduct(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PlanningProductWireFormat = {
  id: string;
  planningNodeId: string;
  productId: string | null;
  name: string;
  classification: string;
};

type NewPlanningProductProps = PartialDeep<PlanningProduct, { recurseIntoArrays: true }>;
export const NewPlanningProduct: (props: NewPlanningProductProps) => PlanningProduct = (props) =>
  new PlanningProduct(props);

type NewPlanningProductFromWireFormatProps = PartialDeep<
  PlanningProductWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPlanningProductFromWireFormat: (
  props: NewPlanningProductFromWireFormatProps,
) => PlanningProduct = (props) => new PlanningProduct(props);
